module.exports = __webpack_public_path__ + "img/mobileBack.0484e3bd.png";